import { render, staticRenderFns } from "./NotificationChannels.vue?vue&type=template&id=d37de060&scoped=true&"
import script from "./NotificationChannels.vue?vue&type=script&lang=js&"
export * from "./NotificationChannels.vue?vue&type=script&lang=js&"
import style0 from "./NotificationChannels.vue?vue&type=style&index=0&id=d37de060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37de060",
  null
  
)

export default component.exports